import { HttpClient } from '@angular/common/http';
import { Data, Response, waitAndRetry } from '@dimandzhi/graphql';
import { currentMethodName } from 'app/current-method-name';
import { GraphQL, } from 'app/graphql';
import { environment as env } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class UsersInGroup {
  constructor(
    protected http: HttpClient
  ) { }

  getUsersInGroup(id: number): Observable<GraphQL.UserSchema.UserInGroup[]> {
    return this.http.post<Response>(`${env.graphqlUser}/${currentMethodName()}`, `
      query {
        User {
          inGroup(id: ${id}) {
            id
            firstName
            lastName
            email
            enabled
            isManager
          }
        }
      }`
    ).pipe(
      waitAndRetry,
      Data.fromResp,
      map(data => GraphQL.UserSchema.UserInGroup.fromData(data, "inGroup"))
    );
  }
}
